const handleGridChange = () => {
  const selectors = {
    container: '.js-product-list',
    grid1: '.js-grid1',
    grid2: '.js-grid2',
  };

  const state = {
    active: 'is-active',
    grid: 'is-active-grid',
  };

  const grid1 = document.querySelector(selectors.grid1);
  const grid2 = document.querySelector(selectors.grid2);
  const container = document.querySelector(selectors.container);

  if (!grid1 || !grid2 || !container) return;

  const toggleDisplay = () => {
    container.classList.toggle(state.grid);
    grid1.classList.toggle(state.active);
    grid2.classList.toggle(state.active);
  };

  grid1.addEventListener('click', () => {
    toggleDisplay();
  });

  grid2.addEventListener('click', () => {
    toggleDisplay();
  });
};

export default handleGridChange;
